import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Button, Grid, Tooltip } from '@material-ui/core';
import { MicOff, CallEnd, Phone, PhoneForwarded } from '@material-ui/icons';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      marginLeft: theme.spacing(2),
      minWidth: 120,
    },
    statusChip: { marginLeft: theme.spacing(1) },
    endCallDisabled: {
      backgroundColor: '#e0e0e0',
      color: '#9e9e9e',
    },
  })
);

export type DialControlsProps = {
  isMuted: boolean;
  hasActiveCall: boolean;
  deviceReady: boolean;

  canDialCurrent: boolean;
  canDialNext: boolean;

  onToggleMute: () => void;
  onHang: () => void;
  onDialCurrent: () => void;
  onDialNext: () => void;

  currentLeadName?: string;
  currentLeadPhone?: string;
};

const DialControls: React.FC<DialControlsProps> = ({
  isMuted,
  hasActiveCall,
  deviceReady,
  canDialCurrent,
  canDialNext,
  onToggleMute,
  onHang,
  onDialCurrent,
  onDialNext,
}) => {
  const classes = useStyles();

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      role="region"
      aria-label="Dialer controls"
    >
      <Grid item>
        <span>
          <Button
            onClick={onToggleMute}
            color="primary"
            size="small"
            className={classes.button}
            startIcon={<MicOff />}
            disabled={!hasActiveCall}
          >
            {isMuted ? 'Unmute' : 'Mute'}
          </Button>
        </span>

        <span>
          <Button
            onClick={onHang}
            size="small"
            className={clsx(classes.button)}
            color="secondary"
            startIcon={<CallEnd />}
            disabled={!hasActiveCall}
          >
            End Call
          </Button>
        </span>
      </Grid>

      <Grid item>
        <span>
          <Button
            className={classes.button}
            variant="contained"
            size="small"
            color="primary"
            onClick={onDialCurrent}
            disabled={!canDialCurrent || !deviceReady}
            startIcon={<Phone />}
            aria-label="Dial current lead"
          >
             Dial Current Lead
          </Button>
        </span>

        <span>
          <Button
            className={classes.button}
            variant="contained"
            size="small"
            color="primary"
            onClick={onDialNext}
            disabled={!canDialNext || !deviceReady}
            startIcon={<PhoneForwarded />}
            aria-label="Dial next lead"
          >
             Dial Next Lead
          </Button>
        </span>
      </Grid>
    </Grid>
  );
};

export default DialControls;
